import React from 'react'
import { t } from '@lingui/core/macro'
import Header from '../Header/Header'
import styles from './LoadingOverlay.module.css'

const LoadingOverlay = () => {
    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <Header />

                <div className={styles.content}>
                    <div className={styles.loading}>{t`Загрузка...`}</div>
                </div>
            </div>
        </div>
    )
}

export default LoadingOverlay
